import { Injectable, inject } from '@angular/core';
import { ISemester, ISemesterCreateUpdate } from '../../../shared/types/model/semester.type';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { EntityServiceInterface } from '../../../shared/entity-service';
import { IId, IIdLockVersion } from '../../../shared/types/model/base.type';

@Injectable({
  providedIn: 'root',
})
export class SemesterService implements EntityServiceInterface<number, ISemesterCreateUpdate, ISemester> {
  private http = inject(HttpClient);

  findById(id: number): Observable<ISemester> {
    return this.http.get<ISemester>(`/semesters/${id}`);
  }

  create(data: ISemesterCreateUpdate): Observable<ISemester> {
    return this.http.post<ISemester>('/semesters', data);
  }

  save(data: ISemesterCreateUpdate): Observable<ISemester> {
    return this.http.put<ISemester>('/semesters', data);
  }

  current(): Observable<ISemester> {
    return this.http.get<ISemester>('/semesters/current');
  }

  delete(id: number, lockVersion: number): Observable<void> {
    const body: IIdLockVersion = { id, lockVersion };
    return this.http.delete<void>('/semesters', { body });
  }

  restore(id: number): Observable<void> {
    const body: IId = { id };
    return this.http.put<void>('/semesters/restore', body);
  }
}
